import { MdPeopleAlt } from 'react-icons/md'
import { useTranslation } from 'react-i18next'

import Header from '@components/configurations/header'
import ProjectsTable from '@components/configurations/users_config/projects'

export const Projects = () => {
	const { t } = useTranslation()

	return (
		<>
			<Header
				title={t('Projects & Roles')}
				icon={<MdPeopleAlt style={{ fontSize: '35px', color: '#707070' }} />}
			/>

			<ProjectsTable />
		</>
	)
}
